exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".donation-button[data-v-423b6a46] {\n  position: relative;\n}\n.donation-button .close[data-v-423b6a46] {\n  position: absolute;\n  top: 1rem;\n  right: 3rem;\n  z-index: 9999999;\n  font-size: 1.5rem;\n}", ""]);

// exports
